export default __webpack_public_path__ + "static/media/hp-arrow.c4c18ddc.svg";